import React from "react";
import { viabilidadClass } from "../lib/api";

export default function Semaforo({ viabilidad, size = "md", compact = false }) {
  const cls = viabilidadClass(viabilidad);
  if (compact) {
    return (
      <span
        className={`status-dot ${cls}`}
        data-testid={`semaforo-${cls}`}
        title={viabilidad}
      />
    );
  }
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      className={`pill ${cls} ${pad}`}
      data-testid={`semaforo-${cls}`}
    >
      <span className={`status-dot ${cls}`} />
      {viabilidad}
    </span>
  );
}

export function SemaforoLarge({ viabilidad }) {
  const items = [
    { key: "Alta", color: "#15803D", label: "Viabilidad alta" },
    { key: "Condicionada", color: "#B45309", label: "Viabilidad condicionada" },
    { key: "A revisar", color: "#991B1B", label: "A revisar" },
  ];
  return (
    <div className="flex items-center gap-4">
      {items.map((it) => {
        const active = it.key === viabilidad;
        return (
          <div
            key={it.key}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg border ${
              active
                ? "border-gray-900 bg-gray-50"
                : "border-gray-200 opacity-40"
            }`}
          >
            <div
              className="w-3.5 h-3.5 rounded-full"
              style={{
                background: it.color,
                boxShadow: active ? `0 0 0 4px ${it.color}30` : "none",
              }}
            />
            <span
              className={`text-xs font-semibold ${
                active ? "text-gray-900" : "text-gray-500"
              }`}
            >
              {it.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
